import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {useForm} from "react-hook-form";
import OrderCard from "./OrderCard";
import CustomerCard from "./CustomerCard";
import ShippingAddressCard from "./ShippingAddressCard";
import Products from "./Products";
import SummaryCard from "./SummaryCard";
import SubmitButton from "../../../Components/Buttons/SubmitButton";
import ReactSelectInput from "../../../Components/Inputs/ReactSelectInput";
import {PAYMENT_METHODS} from "../../../Constants/Constants";
import WarrantyCard from "../WarrantyCard";
import BasicAlert from "../../../Components/Alerts/BasicAlert";

export default function () {
  const {reset, control, handleSubmit, register, watch, setValue} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [alertData, setAlertData] = useState(null);
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`orders/${id}/edit`).then(res => {
      setData(res.data);
      reset(
        {
          products: res.data.order.products,
          ...res.data.order
        },
      )
    }).catch(err => {
      if (err.response.status === 403) {
        navigate('/orders');
      }
    })
  }, []);

  const editOrder = formData => {
    axios.put(`orders/${id}`, formData).then(res => {
      navigate('/orders');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data.errors || {});
      }
    });
  }

  const validateOrderData = async () => {
    let success = false;

    try {
      const res = await axios.post(`orders/${id}/validate-data`, watch());
      if (res.data.status === 'success') {
        setErrors({});
        success = true;
      }
    } catch (err) {
      if (err.response) {
        setErrors(err.response.data.errors || {});
      }
    }

    return success;
  };

  const handleGenerateWarranty = (data) => {
    axios.post(`/update-warranty`, data).then((res) => {
      setAlertData({
        title: "Success!",
        body: res.data.message || "Warranty updated successfully.",
        alertClass: "alert alert-success", // Custom class for styling
      });
      setTimeout(() => setAlertData(null), 3000); // Clear alert after 3 seconds
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data.errors || {});
      }
    });
  };

  return (
    <>
      {data.order && (
        <form onSubmit={handleSubmit(editOrder)}>
          <div className="card-body row">
            <OrderCard data={data} order={data.order}/>
            <CustomerCard customer={data.order.user}/>
            <ShippingAddressCard {...{
              register,
              watch,
              errors,
              validateData: validateOrderData,
              setValue,
              address: watch('shippingAddress')
            }}/>
            <Products
              {...{register, watch, control, setValue, errors, validateData: validateOrderData, data, setData}}
            />
            <SummaryCard order={data.order}/>
            <div className="col-xxl-12 pt-5">
              <div className="card card-flush py-4 flex-row-fluid">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Status</h2>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <ReactSelectInput
                    label="Order status"
                    name="status"
                    control={control}
                    errorMessage={errors?.status}
                    options={data?.orderStatuses}
                  />

                  {
                    watch('payment_method') && watch('payment_method') === PAYMENT_METHODS.DIRECT_TRANSFER && (
                      <ReactSelectInput
                        label="Payment Status"
                        name="payment_status"
                        className="col-md-12 col-sm-12 pt-3"
                        options={data?.paymentStatuses}
                        control={control}
                        errorMessage={errors?.payment_status}
                      />
                    )
                  }
                </div>
              </div>
            </div>

            {data.warranty && (
                <WarrantyCard
                    warranty={data.warranty}
                    onGenerate={handleGenerateWarranty}
                />
            )}
            {alertData && <BasicAlert {...alertData} />}
            {
              Object.values(errors).length > 0 && (
                <div className="col-xxl-12 pt-5">
                  <div className="card card-flush py-4 flex-row-fluid">
                    <div className="card-header">
                      <div className="card-title">
                        <h2>Validation Errors</h2>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      {Object.values(errors).map((item, key) => {
                        return (
                          <div key={key} className="fv-plugins-message-container invalid-feedback">
                            <div>{item}</div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              )
            }

            <div className="col-12">
              <SubmitButton
                title="Update"
                classes="w-auto d-inline-block mt-3"
              />
            </div>
          </div>
        </form>

      )}
    </>
  );
}